import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
const NegativeProfileMasterCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [name, setName] = useState("");
  const [nameState, setNameState] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  useEffect(() => {
    (async () => {
      if (params.id) {
        // Get Data from API
        setCallInProgress(true);
        const result = await apiHandler({
          url: endpoint.NEGATIVE_PROFILE_MASTER_FINDBYID + params.id,
          authToken: authToken,
        });
        setCallInProgress(false);
        setName(result?.data?.name)
      }
    })();
  }, []);

  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (name === "") {
      setNameState(true);
    } else {
      setNameState(false);
    }
    if (name) {
      return true;
    } else {
      return false;
    }
  };
  const editInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.NEGATIVE_PROFILE_MASTER_UPDATE + params?.id, 
      method: "PUT",
      authToken: authToken,
      data: {
        name:name?.toUpperCase()
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const saveInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.NEGATIVE_PROFILE_MASTER_CREATE,
      method: "POST",
      authToken: authToken,
      data: {
        name:name?.toUpperCase()
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const handleDueDiligenceSubmit = async (event) => {
    if (isValidated()) {
      toastUpdate("", "", false);
      let status = "";
      if (params.id) {
        status = await editInformation();
      } else {
        status = await saveInformation();
      }
      if (status === "SUCCESS") {
        const msg = params.id
          ? "Negative Profile updated successfully!"
          : "Negative Profile created successfully!";
          toastUpdate("Success", msg, true);
        setRedirectURL(`/coreservice/DueDiligence`);
      }
    }
  };
  const handleCancel = () => {
    navigate("/coreservice/DueDiligence");
  };
  const handleChange = (e) => {
      setName(e);
    if(e === ''){
        setDisabledButton(true);
    }else{
        setDisabledButton(false);
    }
  }
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params.id ? "Edit Negative Profile" : "Create Negative Profile"}
          button1=" Save"
          button2=" Cancel"
          button1click={handleDueDiligenceSubmit}
          button2click={handleCancel}
          disabled1={disabledButton}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Name"
              required
              error={nameState}
              id="lp_min_name"
              value={name || ""}
              setState={handleChange}
              setError={setNameState}
              type="notCapital"
            />
          </Grid>
        </Grid>
      </Grid>
   
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default NegativeProfileMasterCreate;
